import { classNames } from '../../util';
export var HANDLE_ICON_DEFAULT_CFG = {
    fill: '#fff',
    lineWidth: 1,
    radius: 2,
    size: 10,
    stroke: '#bfbfbf',
    strokeOpacity: 1,
    zIndex: 0,
};
export var HANDLE_LABEL_DEFAULT_CFG = {
    fill: '#000',
    fillOpacity: 0.45,
    fontSize: 12,
    textAlign: 'center',
    textBaseline: 'middle',
    zIndex: 1,
};
export var HANDLE_DEFAULT_CFG = {
    x: 0,
    y: 0,
    orientation: 'horizontal',
    showLabel: true,
    type: 'start',
};
export var CLASS_NAMES = classNames({
    foreground: 'foreground',
    handle: 'handle',
    selection: 'selection',
    sparkline: 'sparkline',
    sparklineGroup: 'sparkline-group',
    track: 'track',
    brushArea: 'brush-area',
}, 'slider');
//# sourceMappingURL=constant.js.map